module.exports = __webpack_public_path__ + "img/Cademi-4-pt.084b7c44.png";